import Mediator from "../Utilities/Mediator";
import ITablePaginator from "./ITablePaginator";
import TablePager from "./TablePager";

export default class TablePaginator {
	table: ITablePaginator;
	currentPage: number;// from backend
	total: number;		// from backend
	pageSize: number;	// from backend
	next: HTMLSpanElement;
	prev: HTMLSpanElement;
	itemsPerPage: NodeListOf<HTMLSpanElement>;

	constructor(table: ITablePaginator) {
		this.table = table;
		this.next = document.getElementById('next');
		this.prev = document.getElementById('prev');
		this.itemsPerPage = document.querySelectorAll('tfoot td:last-child span');
		this.currentPage = 1;
		this.pageSize = 10;
		Mediator.on("currentPageChanged", (pageNumber) => this.changePage(pageNumber));
	}

	public renderFoot() {
		new TablePager(this.currentPage, this.LastPage);
		this.changeNextPrevDisableClasses();
		this.selectItemsPerPageLimitNumber();
	}

	private changeNextPrevDisableClasses() {
		if (this.islastPage) {
			this.next.classList.add('disabled');
		} else {
			this.next.classList.remove('disabled');
		}
		if (this.currentPage > 1) {
			this.prev.classList.remove('disabled');
		} else {
			this.prev.classList.add('disabled');
		}
	}

	private selectItemsPerPageLimitNumber() {
		// Desktop view
		this.itemsPerPage.forEach(span => {
			let pageSize: string = `${this.pageSize}`;
			if (span.innerText === pageSize) {
				span.classList.add('current');
			} else {
				span.classList.remove('current');
			}
		});
		// Mobile view
		const itemsBtn: HTMLButtonElement = document.querySelector("button.page-limit");
		itemsBtn.innerText = this.pageSize.toString();
	}

	public addPaginationEventsListeners() {
		this.addNextClickListener();
		this.addPrevClickListener();
		this.addItemsPerPageClickListeners();
	}

	private changePage(pageNumber: number) {
		this.currentPage = pageNumber;
		this.table.fetchList();
	}

	private addNextClickListener() {
		this.next.onclick = () => {
			if (!this.islastPage) {
				this.changePage(this.currentPage + 1);
			}
		}
	}

	private addPrevClickListener() {
		this.prev.onclick = () => {
			if (this.currentPage > 1) {
				this.changePage(this.currentPage - 1);
			}
		}
	}

	private addItemsPerPageClickListeners() {
		// Desktop view
		this.itemsPerPage.forEach(span => {
			span.onclick = () => {
				this.setPageLimit(span);
			}
		});
		// Mobile view
		const listItems: NodeListOf<HTMLSpanElement> =
			document.querySelectorAll('div.dropup span.dropdown-item');
		listItems.forEach(span => {
			span.onclick = () => {
				this.setPageLimit(span);
			}
		});
	}

	private setPageLimit(span: HTMLSpanElement) {
		this.pageSize = parseInt(span.innerText);
		if (this.pageSize > this.total) {
			this.currentPage = 1;
		} else if (this.LastPage < this.currentPage) {
			this.currentPage = this.LastPage;
		}
		this.table.fetchList();
	}

	private get islastPage(): boolean {
		return this.currentPage == this.LastPage;
	}

	private get LastPage(): number {
		if (this.total > 0) {
			return Math.ceil(this.total / this.pageSize);
		}

		return 1;
	}
}
